import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
// import router from "../router";
import { getToken } from "@/utils/auth";
import { addBtnLoading, removeBtnLoading } from "./btnLoading"; //composedPath

export const IS_DEV = process.env.VUE_APP_NODE_ENV === "开发环境";
const appSetting = window.appSetting;
const { BaseServeUrl = "", FileServeUrl = "" } = appSetting || {};
const { VUE_APP_BASE_API, VUE_APP_BASE_UPLOAD_URL } = process.env;
export const BASE_URL = IS_DEV ? VUE_APP_BASE_API : BaseServeUrl;
export const UPLOAD_BASE_URL = IS_DEV ? VUE_APP_BASE_UPLOAD_URL : FileServeUrl;

export const showTips = (message, type, duration, showClose) => {
  message &&
    Message({
      message,
      type: type || "error",
      duration: duration || 5000,
      showClose: showClose || false,
    });
};

const service = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
});

service.interceptors.request.use(
  (config) => {
    /* 默认走网关  */
    const { gate = true, url } = config;
    if (store.getters.token) {
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    if (!url.includes("_") && gate) config.url = '/c_api' + config.url
    // 请求中存在按钮信息时，则将按钮加上loading效果
    // addBtnLoading(composedPath(config.eTarget))
    if (config.eTarget) addBtnLoading(config.eTarget);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    const { eTarget, unShowErrorTip = false } = response.config;
    if (eTarget) {
      // let btn = composedPath(eTarget);
      removeBtnLoading(eTarget);
    }
    if (response.request.responseType === "blob") return response;
    const { data: resp } = response;
    const { state, msg } = resp || {};
    if (state === 0) return resp;
    if (state === 401) {
      const cb = () => showTips(msg, "error", 5000, true);
      store.dispatch("user/loginExpiration", { cb }); /* 登录过期 */
      return Promise.reject(resp);
    }
    !unShowErrorTip && showTips(msg, "error", 5000, true);
    return Promise.reject(resp);
    // return resp;
  },
  (error) => {
    const { eTarget, unShowErrorTip = false } = error.config;
    if (axios.isCancel(error) && !console.error("当前请求已取消"))
      return Promise.reject(error);
    if (eTarget) {
      // let btn = composedPath(eTarget);
      removeBtnLoading(eTarget);
    }
    if (error && error.response) {
      if (error.response.status === 401) {
        const cb = () => showTips("登录过期，请重新登录", "error", 1000, true);
        store.dispatch("user/loginExpiration", { cb }); /* 登录过期 */
        return Promise.reject(error);
      }
      const msg = "系统报错，联系客服处理";
      !unShowErrorTip && showTips(msg, "error", 2500, true);
    }
    return Promise.reject(error);
  }
);
export default service;
